import { useLang } from 'hooks/lang';

import { Card, Tag, Row, Box } from 'components/Blocks';

import { LocationPinIcon, UsersIcon, CircleDollarIcon } from 'components/Icons';
import { IconBox } from '../IconBox';
import { NumCount } from '../NumCount';

import { ClientBalanceOverview } from 'entities';

interface Props {
  data: ClientBalanceOverview;
}

export function BalanceOverview({ data }: Props): JSX.Element {
  const { t } = useLang();

  return (
    <Row
      className="small_tablet:w-full small_tablet:flex-col"
      gap="6"
      justifyContent="center"
      alignItems="stretch"
    >
      <Card
        flow="column"
        className="min-h-[130px] min-w-[260px] small_tablet:w-full"
        fullWidth
        gap="2.5"
      >
        <Row justifyContent="space-between">
          <span className="font-medium">{t('clients')}</span>

          <IconBox>
            <UsersIcon />
          </IconBox>
        </Row>

        <NumCount count={data.clients.length} />
      </Card>

      <Card
        flow="column"
        className="min-h-[130px] min-w-[260px] small_tablet:w-full"
        fullWidth
        gap="2.5"
      >
        <Row justifyContent="space-between">
          <span className="font-medium">{t('by-currencies')}</span>

          <IconBox>
            <CircleDollarIcon />
          </IconBox>
        </Row>

        <Row gap="3" flexWrap="wrap" justifyContent="center" className="mt-2">
          {Object.entries(data.byCurrency).map(([currency]) => (
            <Tag key={currency} color="muted" name={currency} round={false} className="text-xs" />
          ))}
        </Row>
      </Card>

      <Card
        flow="column"
        className="min-h-[130px] min-w-[260px] small_tablet:w-full"
        fullWidth
        gap="2.5"
      >
        <Row justifyContent="space-between">
          <span className="font-medium"> {t('by-country')}</span>

          <IconBox>
            <LocationPinIcon size={22} />
          </IconBox>
        </Row>

        <Row flexWrap="wrap">
          {Object.entries(data.byCountry).map(([country, currencies]) => (
            <Row gap="1.5" key={country} fullWidth={false}>
              <div className="text-sm font-medium">{country}</div>

              <Box
                border="circle"
                backgroundColor="#edf8ff"
                className="text-sm font-medium text-primary"
                size={24}
              >
                {Object.keys(currencies).length}
              </Box>
            </Row>
          ))}
        </Row>
      </Card>
    </Row>
  );
}
